var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenLocMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 20.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#48bd9e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.5,0C4,0,0,2,0,7.78c0,5.56,6.53,12,6.81,12.33a1,1,0,0,0,1.38,0C8.47,19.83,15,13.34,15,7.78,15,2,11,0,7.5,0Zm0,18C5.88,16.23,2,11.57,2,7.78,2,2.37,6.2,2,7.5,2S13,2.37,13,7.78C13,11.56,9.12,16.23,7.5,18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.5,3.58a3.86,3.86,0,1,0,3.87,3.85A3.87,3.87,0,0,0,7.5,3.58Zm0,6.25a2.4,2.4,0,1,1,2.4-2.4A2.41,2.41,0,0,1,7.5,9.83Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenLocMark);
export default __webpack_public_path__ + "static/media/green_loc_mark.539a10eea457df5a082906cdc24e7eea.svg";
export { ForwardRef as ReactComponent };